import { Grid, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import { Favorite, Money, People, Shop, ShoppingBag } from "@mui/icons-material";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
    BarElement,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import axios from 'axios';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

ChartJS.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend
);

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

export default function Homee() {
    var navi = useNavigate();

    const data = {
        labels: ["01", "02", "03", "04", "05", "06", "07", "08", "09"],
        datasets: [
            {
                data: [850, 600, 500, 620, 880, 480, 900, 620, 890],
                backgroundColor: "#fff",
                borderRadius: 3,
                barThickness: 18,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { color: "#ffffff" },
            },
            y: {
                beginAtZero: true,
                max: 1000,
                ticks: {
                    stepSize: 200,
                    color: "white",
                },
                grid: {
                    color: "rgba(255,255,255,0.2)",
                    borderDash: [5, 5],
                },
            },
        },
        animation: {
            duration: 1300,
            easing: "ease in",
            // true:true
        },
    };


    const linedata = {
        labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [
            {
                label: "Traffic",
                data: [50, 30, 300, 220, 500, 260, 400, 230, 500],
                borderColor: "#3b82f6",
                backgroundColor: "rgba(59,130,246,0.15)",
                tension: 0.4,
                fill: true,
            },
            {
                label: 'Sales',
                data: [30, 50, 100, 200, 350, 100, 304, 170, 400],
                borderColor: '#9389FE',
                tension: .4,
                fill: true
            }
        ],
    };

    

    return (
        <>
            <Grid container height={'100vh'} className='' width={'100%'}>
                <Sidebar />
                <Grid height={'100%'} size={{ xs:12,lg: 10 }} px={3.3} pt={3}>
                    {/* <Grid container justifyContent={'space-between'}>
                        <Grid size={{ lg: 2.8 }} p={2} container alignItems={'center'} className='admin-section bg-dark shadow'>
                            <div className="col-lg-9">
                                <Typography variant="subtitle1" className="text-secondary fw-bold">Today's Sales</Typography>
                                <Typography fontSize={25} fontFamily={'sans-serif'} fontWeight={'bold'}>$53,000</Typography>
                            </div>
                            <div className="col-lg-3 px-1">
                                <div className="bg-admin-selected fw-bold shadow-sm dollar">
                                    $
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ lg: 2.8 }} p={2} container alignItems={'center'} className='admin-section bg-dark shadow'>
                            <div className="col-lg-9">
                                <Typography variant="subtitle1" className="text-secondary fw-bold">Today's Users</Typography>
                                <Typography fontSize={25} fontFamily={'sans-serif'} fontWeight={'bold'}>3,000</Typography>
                            </div>
                            <div className="col-lg-3 px-1">
                                <div className="bg-admin-selected fw-bold shadow-sm dollar">
                                    <People />
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ lg: 2.8 }} p={2} container alignItems={'center'} className='admin-section bg-dark shadow'>
                            <div className="col-lg-9">
                                <Typography variant="subtitle1" className="text-secondary fw-bold">New Clients</Typography>
                                <Typography fontSize={25} fontFamily={'sans-serif'} fontWeight={'bold'}>100</Typography>
                            </div>
                            <div className="col-lg-3 px-1">
                                <div className="bg-admin-selected fw-bold shadow-sm dollar">
                                    <Favorite />
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ lg: 2.8 }} p={2} container alignItems={'center'} className='admin-section bg-dark shadow'>
                            <div className="col-lg-9">
                                <Typography variant="subtitle1" className="text-secondary fw-bold">New Orders</Typography>
                                <Typography fontSize={25} fontFamily={'sans-serif'} fontWeight={'bold'}>1,200</Typography>
                            </div>
                            <div className="col-lg-3 px-1">
                                <div className="bg-admin-selected fw-bold shadow-sm dollar">
                                    <ShoppingBag />
                                </div>
                            </div>
                        </Grid>
                    </Grid> */}
                    <div className="admin-section-cont pt-5">
                        <div className="bar-paper bg-admin-navy shadow text-white">
                            <div className="p-3 bar-cont">
                                <Bar data={data} className="position-relative" options={options} />
                                {/* <Bar data={data} className="position-relative" options={options} /> */}
                            </div>
                            <Typography variant="h6" className="mt-2 fw-bold">Active Users</Typography>
                        </div>
                        <div className="line-paper bg-admin-navy">
                            <Line data={linedata} options={{
                                responsive: true, plugins: {
                                    legend: {
                                        position: 'bottom',
                                        align: 'start',
                                        onClick: function () {

                                        }
                                    }
                                }, animation: {
                                    duration: 1000,
                                    easing: 'easeInOutBack'
                                }
                            }} />;
                        </div>
                    </div>
                </Grid>
            </Grid>

        </>
    )

}